import { TranslatePipe } from "@ngx-translate/core";

import { ChangeDetectionStrategy, Component, computed, input, output } from "@angular/core";

import { TabConfig } from "./tab-config";
import { SubscriptionDetailTab } from "./tab-types";

@Component({
  selector: "page-tab",
  templateUrl: "page-tab.html",
  styleUrls: ["page-tab.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe],
})
export class PageTabComponent<T> {
  protected activeTab = input<string | undefined>(SubscriptionDetailTab.CONFIG);
  protected tabconfig = input<TabConfig<T>[]>([]);
  protected disabled = input<boolean>(false);

  protected activeTabIndex = computed(() => this.tabconfig().findIndex((tc) => this.activeTab() === tc.keyword));

  activeTabEmitter = output<T>();

  protected select(tab: TabConfig<T>): void {
    this.activeTabEmitter.emit(tab.keyword);
  }
}
